import { tokenKey } from '@/config/index';
export function getToken() {
  return localStorage.getItem(tokenKey);
}
export function setToken(token) {
  localStorage.setItem(tokenKey, token);
}
export function removeToken() {
  localStorage.removeItem(tokenKey);
}
export function getSessionToken() {
  return sessionStorage.getItem(tokenKey);
}
export function setSessionToken(token) {
  sessionStorage.setItem(tokenKey, token);
}
export function removeSessionToken() {
  sessionStorage.removeItem(tokenKey);
}